<template>
	<router-view/>
</template>

<script>
import lib from '@/lib';

export default {
	name: 'App',
	mixins: lib.mixins,
	mounted(){
		window["appComponent"] = this;
	},
};
</script>
